<template>
  <sdPageHeader :title="$t('pages.devPerms.detail')">
    <template v-slot:buttons>
      <div class="page-header-actions">
        <sdButton size="small" type="primary" :loading="buttonLoading" @click="save()">
          <sdFeatherIcons type="save" size="14" />
          {{ $t('common.save') }}
        </sdButton>
        <sdButton size="small" type="primary" @click="selectAll()">
          <sdFeatherIcons type="check" size="14" />
          {{ $t('pages.devPerms.select-all') }}
        </sdButton>
        <sdButton size="small" type="primary" @click="removeAll()">
          <sdFeatherIcons type="x" size="14" />
          {{ $t('pages.devPerms.remove-all') }}
        </sdButton>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <div v-if="isLoading" class="spin">
      <a-spin />
    </div>
    <div v-else>
      <a-row :gutter="16">
        <a-col :span="5">
          <a-menu mode="inline">
            <a-menu-item v-for="(record, index) in records" :key="index" @click="select(index)">
              {{ index }}
            </a-menu-item>
          </a-menu>
        </a-col>
        <a-col :span="19">
          <a-card :title="selectRecord[0].tag" style="margin-bottom: 10px">
            <template #extra>
              <a-button size="small" type="primary" @click="toggleAll(selectRecord)">{{
                $t('pages.devPerms.select-all')
              }}</a-button>
            </template>
            <p v-for="data in selectRecord" :key="data">
              <a-checkbox
                :checked="check(data.path + '|' + method)"
                v-for="method in data.methods"
                :key="method"
                @click="toggleCheck(data.path + '|' + method)"
              >
                <a-tag :color="method == 'post' ? 'pink' : 'purple'"
                  >{{ data.path }} [{{ method.toUpperCase() }}]</a-tag
                >
              </a-checkbox>
            </p>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';

export default {
  name: 'devPermissions',
  components: {
    Main,
  },
  data() {
    return {
      group_id: this.$route.params.id,
      isLoading: true,
      checkAll: false,
      buttonLoading: false,
      indeterminate: true,
      records: [],
      permissions: [],
      selectRecord: [],
      allMethods: [],
    };
  },
  methods: {
    getMethods() {
      this.isLoading = true;
      this.records = [];
      this.$appAxios(this.$endpoints.dev_perms_methods_get).then((resp) => {
        if (resp.data.status) {
          this.records = resp.data.data.methods;

          for (const [key, value] of Object.entries(this.records)) {
            this.selectRecord = this.records[key];
            break;
          }
          this.allMethods = resp.data.data.allMethods;
          this.isLoading = false;
        }
      });
    },
    getPermissions() {
      this.$appAxios.post(this.$endpoints.dev_perms_get, { group_id: this.group_id }).then((resp) => {
        if (resp.data.status) {
          this.permissions = resp.data.data;
        }
      });
    },
    check(path) {
      return this.permissions.includes(path);
    },
    toggleCheck(path) {
      if (this.permissions.includes(path)) {
        let index = this.permissions.indexOf(path);
        this.permissions.splice(index, 1);
      } else {
        this.permissions.push(path);
      }
    },
    save() {
      this.buttonLoading = true;
      const formData = {
        group_id: this.group_id,
        permissions: this.permissions,
      };
      this.$appAxios.post(this.$endpoints.dev_perms_set, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        }
        this.buttonLoading = false;
      });
    },
    toggleAll(records) {
      records.forEach((record) => {
        record.methods.forEach((method) => {
          let perms = record.path + '|' + method;
          if (this.permissions.includes(perms) == false) {
            this.permissions.push(perms);
          }
        });
      });
    },
    select(index) {
      this.selectRecord = this.records[index];
    },
    selectAll() {
      this.allMethods.forEach((method) => {
        if (this.permissions.includes(method) == false) {
          this.permissions.push(method);
        }
      });
    },
    removeAll() {
      this.permissions = [];
    },
  },
  created() {
    this.getMethods();
    this.getPermissions();
  },
};
</script>